import shopPayService from './shopPay';

export default shopPayService;
